package app.nestbridge.feature.messages.screen

import com.karawek.core.circuit.Parcelize
import com.slack.circuit.runtime.CircuitUiState
import com.slack.circuit.runtime.screen.Screen

@Parcelize
data object MessagesScreen : Screen

data class MessagesState(
    val eventSink: (MessagesEvent) -> Unit,
) : CircuitUiState

sealed interface MessagesEvent
